import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { renameProjectAPI } from "../projectApis";
import { useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store";
import { svg } from "../../../../Assets/svg";

interface RenameProjectModalProps {
  open: boolean;
  onClose: () => void;
  projectData: any;
}

const RenameProjectModal: React.FC<RenameProjectModalProps> = ({
  open,
  onClose,
  projectData,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (open && projectData) {
      form.setFieldsValue({
        new_project_no: projectData.project_no || projectData.folder_name || "",
      });
    }
  }, [open, projectData, form]);

  const handleFinish = async (values: { new_project_no: string }) => {
    if (!projectData?._id) return;
    
    setLoading(true);
    dispatch(
      renameProjectAPI({
        payload: {
          id: projectData._id,
          new_project_no: values.new_project_no,
        },
        onSuccess: () => {
          setLoading(false);
          queryClient.invalidateQueries({ queryKey: ["projects"] });
          onClose();
        },
        onError: () => {
          setLoading(false);
        },
      })
    );
  };

  return (
    <Modal
      centered
      title={
        <div className="text-center fs-4 fs-4-mobile fw-bolder lh-m mb-4">
          Rename Project Folder
        </div>
      }
      open={open}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      className="commonModalClass"
      width={500}
      footer={
        <div className="d-flex align-items-center justify-content-center gap-3 gap-sm-2">
          <Button
            className="btn btn-lg btn-outline-secondary px-4 h-auto text-uppercase"
            style={{ minWidth: "140px" }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="btn btn-lg btn-primary px-4 h-auto text-uppercase"
            style={{ minWidth: "140px" }}
            onClick={() => form.submit()}
            loading={loading}
          >
            Rename
          </Button>
        </div>
      }
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
      >
        <Form.Item
          label={<span className="fw-medium text-dark">New Project Number</span>}
          name="new_project_no"
          rules={[
            { required: true, message: "Please enter the new project number" },
            { pattern: /^\d+$/, message: "Project number must contain only numbers" }
          ]}
          required={false}
        >
          <Input 
            className="form-control form-control-lg" 
            placeholder="e.g. 00001" 
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameProjectModal;
